import axios from "axios";
import Swal from "sweetalert2";

// const baseURL = "http://127.0.0.1:8000/api";
 const baseURL = "https://crm.ssdntech.com/api";
  // const baseURL = "https://testcrm.ssdneducation.com/api";
const api = axios.create({
  baseURL: baseURL,
});


// Attach token automatically
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("crm_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


// Global API Error & Refresh Token Handler
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.response.use(
  (response) => {
    return response;
  },

  async (error) => {
    const originalRequest = error.config;

    // Handle 401 Expired Token
    if (
      error.response &&
      error.response.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/auth/refresh-token") &&
      !originalRequest.url?.includes("/auth/microsoft-login")
    ) {
      originalRequest._retry = true;

      const refreshToken = sessionStorage.getItem("crm_refresh_token");

      if (refreshToken) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return api(originalRequest);
            })
            .catch((err) => Promise.reject(err));
        }

        isRefreshing = true;

        try {
          const res = await axios.post(`${baseURL}/auth/refresh-token`, {
            refresh_token: refreshToken,
          });

          const newAccessToken = res.data.access_token;
          const newRefreshToken = res.data.refresh_token;

          sessionStorage.setItem("crm_token", newAccessToken);
          if (newRefreshToken) {
            sessionStorage.setItem("crm_refresh_token", newRefreshToken);
          }

          api.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

          processQueue(null, newAccessToken);
          isRefreshing = false;

          return api(originalRequest);
        } catch (refreshErr) {
          processQueue(refreshErr, null);
          isRefreshing = false;

          sessionStorage.clear();

          Swal.fire({
            icon: "warning",
            title: "Session Expired",
            text: "Your session has expired. Please log in again.",
          }).then(() => {
            window.location.href = "/login";
          });

          return Promise.reject(refreshErr);
        }
      }
    }

    if (error.response) {
      if (error.response.status === 403) {
        return Promise.reject(error);
      }

      // Backend responded with error
      const message =
        error.response.data?.detail ||
        error.response.data?.message ||
        "Something went wrong";

      Swal.fire({
        icon: "error",
        title: "Error",
        text: message,
      });
    } else if (error.request) {
      // No response received (backend down/network issue)
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "An unexpected error occurred. Please contact the engineering team.",
      });
    }

    return Promise.reject(error);
  }
);


export default api;